import type { RouteObject } from 'react-router';

/**
 * `/stats` (017 AC-03). One lazy chunk holding one screen — there is no list/detail split here the
 * way `containers.routes.tsx` has, because the dashboard *is* the whole surface. No inputs: the page
 * reads the practitioner's preferences itself, so a bare route is all there is to bind.
 */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./stats-page')).default }) },
];
